<template>
  <div id="app" class="container">
    <Header :msg="$t('titulo')"/>
    <div class="wrapper">
      <router-view />
    </div>
    <Footer />
  </div>
</template>

<script>
import Vue from 'vue'

import Header from "./components/Header.vue";
import Footer from "./components/Footer.vue";

export default {
  name: "App",
  components: {
    Header,
    Footer,
  },

  async beforeCreate() {
    window.console.log('Starting application version check ..')

    let jsonURL = process.env.VUE_APP_VERSION_URL
    window.console.log(`Trying ${jsonURL} ...`)

    let versionJSON = (await Vue.axios.get(`${jsonURL}`)).data
    let htmlBuildVersion = document.getElementsByTagName("configuration")[0].attributes.VUE_APP_GIT_VERSION.value
    let htmlBuildDate = document.getElementsByTagName("configuration")[0].attributes.VUE_APP_BUILD_DATE.value

    window.console.log('**************************************************************************')
    window.console.log('HTML        client version    :', htmlBuildVersion)
    window.console.log('HTML        client build date :', htmlBuildDate)

    window.console.log('application server version    :', versionJSON.version, versionJSON.buildDate)
    window.console.log('application server build date :', versionJSON.version, versionJSON.buildDate)
    window.console.log('application server info       :', versionJSON)
    window.console.log('**************************************************************************')

    if(versionJSON.version !== htmlBuildVersion) {
      Vue.axios.get('/noq/api/version/mismatch')
      window.alert("Su navegador está usando una version anterior de la aplicacion. Va a procederse a su actualización.")
      window.location.reload()
    }
  },
};
</script>

<style>
#app {
  padding: 0;
}
.wrapper {
  padding: 0rem;
  min-height: 70vh;
}
</style>

